import React, { useState, useEffect, useRef } from 'react'
import Modal from 'react-modal'
// import LinesEllipsis from 'react-lines-ellipsis'
import arrowUp from './../assets/images/stamp/ic-arrowup.svg'
import arrowDown from './../assets/images/stamp/ic-arrowdown.svg'
import arrowNext from './../assets/images/stamp/ic-arrow-next.svg'
import arrowPrev from './../assets/images/stamp/ic-arrow-prev.svg'
import closeBtn from './../assets/images/stamp/ic-close.svg'

// const dataMockup = {
//     "campaign": {
//         "id": 126,
//         "type": "stamp",
//         "user_type": "isms_code",
//         "name": "test create stamp2",
//         "group_id": -1,
//         "start_date": "2023-11-01 00:00:00",
//         "end_date": "2023-12-31 23:59:59",
//         "status": "ongoing",
//         "created_time": "2023-11-19 11:11:43",
//         "modified_time": "2023-11-23 13:42:56",
//         "modified_by": 3,
//         "end_processing_time": null,
//         "lock_upload": 0,
//         "lock_background": 0,
//         "background_id": 0,
//         "last_target_upload": "2023-11-22 17:42:18",
//         "last_progress_upload": "2023-11-27 14:20:01",
//         "last_team_upload": null,
//         "group": null,
//         "stamp": {
//             "banner_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/monthlyshort/_1699499752021_.jpg",
//             "background_picture": null,
//             // "background_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/background_picture.jpg",
//             "background_color": "ccc",
//             "text1": "text1",
//             "text2_choice": 1,
//             "text_color": "000000",
//             "no_stamp": 15,
//             "stamp_empty_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/stamp_empty_picture.png",
//             "stamp_taken_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/stamp_taken_picture.png",
//             "show_numbers_on_empty_stamp": 1,
//             "number_color": "333333",
//             "show_reward_details_section": 0,
//             "reward_details_text_color": "00ffff",
//             "show_barcode_scanner": 1,
//             "barcode_scanner_group": "gt",
//             "scanner_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/scanner_picture.png",
//             "sku": [
//                 "FA020743",
//                 "FA061815",
//                 "FA063013",
//                 "FA064693",
//                 "FA064694",
//                 "FA065903",
//                 "FA070958"
//             ],
//             "reward": [
//                 {
//                     "id": 1,
//                     "stamp_no": 9,
//                     "reward_name": "Lorem Ipsum 5",
//                     "reward_details": "<h3 style='color: red;'>simply dummy text of the printing and typesetting industry.</h3><br/> Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
//                     "reward_type": "sfdc",
//                     "prize_theme_id": 1,
//                     "sfdc_point": 2,
//                     "ecoupon_face_value": 3,
//                     "ecoupon_topup": 1,
//                     "ecoupon_custom_text": "custom",
//                     "icon_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_earned.png",
//                     "icon_not_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_not_earned.png",
//                     "prize_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/prize_picture.png",
//                     "expire_mode": "date",
//                     "expire_days": 20,
//                     "expire_date": "2024-12-31"
//                 },
//                 {
//                     "id": 2,
//                     "stamp_no": 10,
//                     "reward_name": "Lorem Ipsum 10",
//                     "reward_details": '<h1 id="h_9a1e311f-afdb-4f88-b149-66dd5daacd38">Update Existing Text Layers</h1><ol><li>Select the Text object(s) in the canvas.</li><li>In the Properties Panel, open the&nbsp;<strong>Advanced Type</strong>&nbsp;menu by clicking on the three dots:&nbsp;<img class="noBdr" src="https://d33v4339jhl8k0.cloudfront.net/docs/assets/5aa962fe2c7d3a2c4983093d/images/5cc1870d04286301e753bb61/file-WG82gMjxnp.png"></li><li>Click the&nbsp;<strong>Update</strong>&nbsp;button in the bottom-right corner:&nbsp;<img class="noBdr" src="https://d33v4339jhl8k0.cloudfront.net/docs/assets/5aa962fe2c7d3a2c4983093d/images/5cc189f62c7d3a026fd4092a/file-5ovWfR2AlM.png"></li><li>The selected Text will now use the new text rendering.</li></ol>',
//                     "reward_type": "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
//                     "prize_theme_id": 1,
//                     "sfdc_point": 2,
//                     "ecoupon_face_value": 3,
//                     "ecoupon_topup": 1,
//                     "ecoupon_custom_text": "custom",
//                     "icon_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_earned.png",
//                     "icon_not_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_not_earned.png",
//                     "prize_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/prize_picture.png",
//                     "expire_mode": "date",
//                     "expire_days": 20,
//                     "expire_date": "2024-12-31"
//                 },
//                 {
//                     "id": 3,
//                     "stamp_no": 11,
//                     "reward_name": "Lorem Ipsum 15",
//                     "reward_details": "<p><h1>Mikel Arteta</h1> swerved the media's questions about Oleksandr Zinchenko's error during Arsenal's 2-1 win over Wolves by insisting that he 'loves the Ukrainian how he is'. The Spaniard has shown once again that he doesn't bash members of his squad when speaking about them publically.&nbsp;</p>",
//                     "reward_type": "prizepool",
//                     "prize_theme_id": 1,
//                     "sfdc_point": 2,
//                     "ecoupon_face_value": 3,
//                     "ecoupon_topup": 1,
//                     "ecoupon_custom_text": "custom",
//                     "icon_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_earned.png",
//                     "icon_not_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_not_earned.png",
//                     "prize_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/prize_picture.png",
//                     "expire_mode": "date",
//                     "expire_days": 20,
//                     "expire_date": "2024-12-31"
//                 },
//                 {
//                     "id": 4,
//                     "stamp_no": 12,
//                     "reward_name": "Lorem Ipsum 20",
//                     "reward_details": "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
//                     "reward_type": "prizepool",
//                     "prize_theme_id": 2,
//                     "sfdc_point": 20,
//                     "ecoupon_face_value": 5,
//                     "ecoupon_topup": 10,
//                     "ecoupon_custom_text": "custom",
//                     "icon_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_earned.png",
//                     "icon_not_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_not_earned.png",
//                     "prize_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/prize_picture.png",
//                     "expire_mode": "date",
//                     "expire_days": 20,
//                     "expire_date": "2024-12-31"
//                 },
//                 {
//                     "id": 5,
//                     "stamp_no": 13,
//                     "reward_name": "Lorem Ipsum 25",
//                     "reward_details": "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
//                     "reward_type": "prizepool",
//                     "prize_theme_id": 3,
//                     "sfdc_point": 10,
//                     "ecoupon_face_value": 10,
//                     "ecoupon_topup": 5,
//                     "ecoupon_custom_text": "custom",
//                     "icon_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_earned.png",
//                     "icon_not_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_not_earned.png",
//                     "prize_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/prize_picture.png",
//                     "expire_mode": "date",
//                     "expire_days": 20,
//                     "expire_date": "2024-12-31"
//                 },
//                 {
//                     "id": 6,
//                     "stamp_no": 22,
//                     "reward_name": "Lorem Ipsum 25",
//                     "reward_details": "simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
//                     "reward_type": "prizepool",
//                     "prize_theme_id": 3,
//                     "sfdc_point": 10,
//                     "ecoupon_face_value": 10,
//                     "ecoupon_topup": 5,
//                     "ecoupon_custom_text": "custom",
//                     "icon_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_earned.png",
//                     "icon_not_earned": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/icon_not_earned.png",
//                     "prize_picture": "https://s3.ap-southeast-1.amazonaws.com/production.pmi-gameworld-upload/progressbar/stamp/default/prize_picture.png",
//                     "expire_mode": "date",
//                     "expire_days": 20,
//                     "expire_date": "2024-12-31"
//                 }
//             ]
//         }
//     },
//     "user": {
//         "progress": 17,
//         "updated_time": "2023-11-27 14:21:01",
//         "scanner_url": "https://google.com"
//     },
//     "version": 2
// }

function Stamp(props) {
    const bannerElement = useRef()
    const rewardItemElment = useRef()
    // const [bannerHeight, setBannerHeight] = useState(0)
    const [modalRewardIsOpen, setModalRewardIsOpen] = useState(false)
    const [modalRewardData, setModalRewardData] = useState({})
    // const [loading, setLoading] = useState(false)
    const [paginationTotal, setPaginationTotal] = useState(0)
    const [paginationCurrent, setPaginationCurrent] = useState(0)
    const [showRewardList, setShowRewardList] = useState(true)
    const [stampRemain, setStampRemain] = useState(0)

    // const dataCampaign = dataMockup // For Test
    const { dataCampaign } = props 
    const dataStamp = dataCampaign.campaign.stamp
    const dataUser = dataCampaign.user;

    // Dimensions data
    const windowWidth = window.innerWidth
    // const windowHeight = window.innerHeight

    // Stamp data
    const stampLimitMax = 10
    const stampProgressAmount = dataUser.progress
    const stampTotal = dataStamp.no_stamp
    // const stampRemain = (stampTotal - stampProgressAmount)
    const stampEmptyShowNumber = dataStamp.show_numbers_on_empty_stamp

    // Reward data
    const dataReward = dataStamp.reward
    const rewardItemHeight = (windowWidth <= 320 ? 84 : windowWidth <= 375 ? 92 : 102) * (dataReward.length >= 4 ? 4 : dataReward.length)

    // Text data
    const stampTitle = dataStamp.text1 || ''
    const stampTitleColor = dataStamp.text_color
    const scannerUrl = dataUser.scanner_url
    const stampSubTitle = dataStamp.text2_choice

    // Images data
    const banner = dataStamp.banner_picture;
    const backgroundContentImg = dataStamp.background_picture
    const iconScan = dataStamp.scanner_picture
    const stampEmptyImage = dataStamp.stamp_empty_picture
    const stampTakenImage = dataStamp.stamp_taken_picture
    // const updateTime = dataUser.updated_time;

    // Color data
    const backgroundContentColor = dataStamp.background_color
    const stampEmptyNumberColor = dataStamp.number_color
    const rewardDetailTextColor = dataStamp.reward_details_text_color



    useEffect(() => {
        console.log(dataCampaign)

        // Calc stamp remain
        calcStampRemain()
        
        // Set banner height 
        // setBannerHeight(bannerElement.current.clientHeight)

        // Set pagination
        setPaginationTotal(Math.ceil(stampTotal / stampLimitMax))
        setPaginationCurrent( (Math.ceil(stampProgressAmount / stampLimitMax)) === 0 ? 1 : Math.ceil(stampProgressAmount / stampLimitMax))

        return () => {
            
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Calc stamp remain to reward
    const calcStampRemain = () => {
        let rewardMorethanProgress = []
        let rewardMinProgress = 0

        // Loop for Compare stamp reward 
        for(let i=0; i<dataReward.length; i++) {
            if(dataReward[i].stamp_no >= stampProgressAmount) {
                rewardMorethanProgress.push(dataReward[i].stamp_no)
            }
        }

        // Find reward min value
        if(rewardMorethanProgress.length)
            rewardMinProgress = Math.min(...rewardMorethanProgress)

        // Set stamp remain
        setStampRemain(rewardMinProgress - stampProgressAmount)
    }

    // Modal reward detail
    const openModalReward = (id) => {
        let result = {}
        for(let i=0; i < dataReward.length; i++) {
            if(id === dataReward[i].id) {
                result = {
                    img: dataReward[i].prize_picture,
                    burnpoint: dataReward[i].stamp_no,
                    name: dataReward[i].reward_name,
                    detail: dataReward[i].reward_details
                }
            }
        }
        setModalRewardData(result)
        setModalRewardIsOpen(true)
    }

    const closeModalReward = () => {
        setModalRewardIsOpen(false)
    }

    // Get stamp item
    const getStampItem = (pageNumber) => {
        let resultLi = []
        let resultUl = {}
        let rewardPosition = []
        let stampPage = 1
        let stampCount = 0
        let stampPerPage = 10

        // Loop for Get reward (stamp_no)
        for(let i=0; i<dataReward.length; i++) {
            rewardPosition.push(dataReward[i].stamp_no)
        }

        // Loop for Get stamp item
        for(let i=0; i < Number(stampTotal); i++) {
            // Set Stamp reward
            for(let j=0; j<rewardPosition.length; j++) {
                // Check reward position & reward amount
                if(i===(rewardPosition[j] - 1) && (rewardPosition[j] - 1 < stampTotal) ) {
                    resultLi.push(
                        <li id={`reward_${i+1}`} key={`reward-${j}`} onClick={()=> openModalReward(dataReward[j].id) }>
                            <div className="stamp-item" style={{ backgroundColor: (!stampEmptyImage? '#d9d9d9': null)}}>
                            {
                                i < stampProgressAmount ?
                                    dataReward[j].icon_earned ? <img src={dataReward[j].icon_earned} alt="stamp earned" /> : null
                                :
                                    dataReward[j].icon_not_earned ? <img src={dataReward[j].icon_not_earned} alt="stamp no earned" /> : null
                            }
                            </div>
                        </li>
                    )
                    i++
                } 
                // console.log(i,', ',rewardPosition[j])
            }

            // Set stamp taken
            if(i < stampProgressAmount) {
                
                resultLi.push(
                    <li id={`stamp_taken_${i+1}`} key={i}>
                        <div className="stamp-item" style={{ backgroundColor: (!stampEmptyImage? '#d9d9d9': null)}}>
                            {
                                stampTakenImage ? <img src={stampTakenImage} alt="stamp taken" /> : null
                            }
                        </div>
                    </li>
                )
            } else {
                // Set stamp empty
                resultLi.push(
                    <li id={`stamp_no_${i+1}`} key={i}>
                        <div className="stamp-item" style={{ backgroundColor: (!stampEmptyImage? '#d9d9d9': null)}}>
                            {
                                stampEmptyShowNumber ? <p style={{color: '#'+stampEmptyNumberColor}}>{i+1}</p> : null
                            }
                            {
                                stampEmptyImage ? <img src={stampEmptyImage} alt="stamp empty" /> : null
                            }
                        </div>
                    </li>
                )
            }
        }
        
        // Check key value compare with no_stamp for Pop last index
        if(Number(resultLi[resultLi.length - 1].key ) === stampTotal) {
            resultLi.pop()
        }

        // Set display stamp list and pagination
        for(let i=0; i<resultLi.length; i++) {
            if(i===(stampPerPage-1)) {
                resultUl[stampPage] = resultLi.slice(stampCount,stampPerPage)
                stampPage += 1
                stampCount += 10
                stampPerPage += 10
            } else {
                // console.log(stampPage, stampCount, stampPerPage, resultLi.length)
                resultUl[stampPage] = resultLi.slice(stampCount,(resultLi.length))
            }
        }
        // console.log('last: ',resultUl)

        return resultUl[pageNumber]
    }

    // Get reward item
    const getRewardItem = () => {
        let result = []
        dataReward.map((item,i)=>{
            return(
                result.push(
                    <li ref={rewardItemElment} key={i} onClick={() => openModalReward(item.id) }>
                        <div className="reward-item">
                            <div className="reward-item-img">
                                <img src={item.icon_earned} alt="icon reward" />
                            </div>
                            <div className="reward-item-figcaption">
                                <div className="reward-item-burnpoint">
                                    <p>เมื่อสะสมครบ <span>{item.stamp_no}</span> ดวง</p>
                                    {
                                        item.stamp_no <= stampProgressAmount ?
                                            <span className="reward-item-earned">[ได้รับแล้ว]</span>
                                        : null
                                    }
                                </div>
                                <p className="reward-item-name" style={{color: '#'+rewardDetailTextColor}}>{item.reward_name}</p>
                                <p className="reward-item-detail" style={{color: '#'+rewardDetailTextColor}} dangerouslySetInnerHTML={{__html: item.reward_details}}></p>
                                {/* <LinesEllipsis
                                    text={item.reward_details}
                                    maxLine='2'
                                    ellipsis='...ดูเพิ่ม'
                                    trimRight
                                    basedOn='letters'
                                /> */}
                            </div>
                        </div>
                    </li>
                )
            )
        })

        return result
    }

    // Show / Hide reward list
    const toggleRewardList = () => {
        setShowRewardList(!showRewardList)
    }

    // Pagination
    const gotoPrev = () => {
        // console.log('prev',paginationCurrent)
        setPaginationCurrent( paginationCurrent - 1)
    }
    const gotoNext = () => {
        // console.log('next',paginationCurrent)
        setPaginationCurrent( paginationCurrent + 1)
    }

    // Go to External
    const openExternalScanner = () => {
        window.parent.location = decodeURIComponent(scannerUrl)
    }
    
    Modal.setAppElement('#root');

    return (
        <div className="App-stamp" style={{backgroundColor: `#${backgroundContentColor}`, backgroundImage: `url(${backgroundContentImg})` /*, height: windowHeight - bannerHeight +'px'*/}}>
            <header className="App-banner" ref={bannerElement}>
                {
                    banner ? 
                    <img src={banner} alt="banner" />
                    :
                    <div className="noimg">
                        No Image
                    </div>
                    
                }
            </header>

            <div className="App-content">
                {/* Stamp Progress */}
                <div className="App-stamp-title">
                    <h3 style={{color: '#'+stampTitleColor}}>{stampTitle}</h3>
                    {
                        !stampSubTitle ? 
                            <p>สะสมแล้ว <span>{stampProgressAmount > stampTotal ? stampTotal : stampProgressAmount}</span> / <span>{stampTotal}</span> ดวง</p>
                        : stampSubTitle === 1 ? 
                            <p>สะสมอีก <span>{stampRemain}</span> ดวง เพื่อรับรางวัลถัดไป</p>
                        : null
                    }
                </div>

                {/* Stamp List */}
                {
                    stampTotal > 0 ?
                        <div className={`App-stamp-list no-${stampTotal}`}>
                            <ul>
                                {
                                    getStampItem(paginationCurrent)
                                }
                            </ul>

                            {/* Stamp pagination */}
                            {
                                stampTotal === 6 ?
                                null 
                                :
                                <div className="App-pagination">
                                    {
                                        (paginationCurrent <= 1) ?
                                        <button className="btn-pagination btn-disable">
                                            <img src={arrowPrev} alt="icon prev" />
                                        </button>
                                        :
                                        <button className="btn-pagination prev" onClick={()=> { gotoPrev() }}>
                                            <img src={arrowPrev} alt="icon prev" />
                                        </button>
                                    }

                                    <p className="num-pagination" style={{color: '#'+rewardDetailTextColor}}>{paginationCurrent} / {paginationTotal}</p>

                                    {
                                        (paginationCurrent >= paginationTotal) ?
                                        <button className="btn-pagination btn-disable">
                                            <img src={arrowNext} alt="icon next" />
                                        </button>
                                        :
                                        <button className="btn-pagination next" onClick={()=> { gotoNext() }}>
                                            <img src={arrowNext} alt="icon next" />
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    : null
                }

                {/* Scan button */}
                {
                    dataStamp.show_barcode_scanner ? 
                        <div className="App-scanbutton">
                            <button onClick={()=> openExternalScanner()}>
                                <img src={iconScan} alt="icon scan" />
                            </button>
                            {/* <a href={scannerUrl} className="App-scanbutton-icon" target="_blank" rel="noreferrer">
                                <img src={iconScan} alt="icon scan" />
                            </a> */}
                        </div>
                    : null
                }

                {/* reward */}
                {
                    dataStamp.show_reward_details_section ? 
                        <div className="App-reward">
                            <div className="App-reward-title">
                                <h4 style={{color: '#'+rewardDetailTextColor}}>ของรางวัล</h4>
                                <div className="reward-accordion" onClick={()=> toggleRewardList() }>
                                    {
                                        !showRewardList ? 
                                            <img src={arrowDown} alt="accordian" />
                                        :
                                            <img src={arrowUp} alt="accordian" />

                                    }
                                </div>
                            </div>
                            {
                                showRewardList ? 
                                    <div className="App-reward-list" style={{height: rewardItemHeight +'px'}}>
                                        <ul>
                                            {
                                                getRewardItem()
                                            }
                                        </ul>
                                    </div>
                                : null
                            }
                            
                        </div>
                    : null 
                }
            </div>

            {/* Modal */}
            <Modal
                isOpen={modalRewardIsOpen}
                onRequestClose={()=> closeModalReward() }
                contentLabel="Reward Modal"
                className="_modal stamp-modal"
                style={{
                    overlay: {
                        backgroundColor: 'rgba(0,0,0,0.5)'
                    },
                }}
            >
                <div className="modal-content">
                    <div className="modal-content-close" onClick={()=> closeModalReward() }>
                        <img src={closeBtn} alt="close"/>
                    </div>
                    <div className="modal-content-body">
                        <div className="modal-content-img">
                            <img src={modalRewardData.img} alt="reward"/>
                        </div>
                        <div className="modal-content-burnpoint">
                            <p>เมื่อสะสมครบ <span>{modalRewardData.burnpoint}</span> ดวง</p>
                        </div>
                        <div className="modal-content-name">
                            <p>{modalRewardData.name}</p>
                        </div>
                        <div className="modal-content-detail" style={{maxHeight: '50vh'}}>
                            <div className="modal-content-detail-box" dangerouslySetInnerHTML={{__html: modalRewardData.detail}}></div>
                        </div>
                    </div>
                </div>
            </Modal>
            </div>
    )
}

export default Stamp